import React, { Component } from 'react';

import ElementWithPopover from '../element-with-popover';
import PaymentSchedule from '../payments-schedule';
import AvatarImg from '../../../components/avatar-img';

import money, { format } from '../../lib/money';
import '../../css/member-card.css';

class MemberCard extends Component {
  constructor(props) {
    super(props);
    this.onRemove = this.onRemove.bind(this);
  }

  onRemove() {
    this.props.onRemoveMember(this.props.membership);
  }

  get shareAmount() {
    return money(this.props.membership.shareAmount);
  }

  contributionSchedule() {
    if (!this.hasContributionSchedule()) return [];

    const { contributions } = this.props.membership;

    return contributions.map(contribution => ({
      status: contribution.status,
      amount: contribution.shareAmount,
      dueDeadline: (contribution.capturedAt || contribution.dueDeadline),
    }));
  }

  hasContributionSchedule() {
    const { contributions } = this.props.membership;
    return contributions && contributions.length > 1;
  }

  renderShareAmount() {
    return (
      <span className="share-amount">
        <b>{format(this.shareAmount)}</b>
        {this.renderPaymentSchedule()}
      </span>
    );
  }

  renderPaymentSchedule() {
    if (!this.hasContributionSchedule()) return null;

    const payments = this.contributionSchedule();
    const content = (
      <PaymentSchedule
        payments={payments}
        totalAmount={this.props.totalAmount}
        refundableAmount={this.props.refundableAmount}
        consumerFee={this.props.consumerFee}
        forMember
      />
    );

    return (
      <ElementWithPopover
        name="member-schedule"
        className="member-schedule-popover d-inline-block"
        content={content}
      >
        <i className="fa fa-fw fa-clock-o cool-grey" />
      </ElementWithPopover>
    );
  }

  render() {
    const { user } = this.props.membership;
    const { email, fullName } = user;

    return (
      <div className="user-card make-purchase-user-card card">
        <div className="card-actions">
          <div className="dropdown">
            <a
              href="#actions"
              className="actions btn dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-h" />
            </a>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <a
                className="dropdown-item"
                href="#remove-from-group"
                onClick={this.onRemove}
              >
                Remove
              </a>
            </div>
          </div>
        </div>
        {this.renderShareAmount()}
        <div className="row">
          <div className="d-flex align-items-center">
            <div className="member-avatar mr-3">
              <AvatarImg user={user} small />
            </div>
            <div className="info">
              <span className="member-name">
                {fullName}
              </span>
              <span className="d-block cool-grey">
                {email}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MemberCard.defaultProps = {
  membership: null,
  organizerName: 'Organizer',
  onRemoveMember: () => {},
  contributions: [],
};

export default MemberCard;



// WEBPACK FOOTER //
// ./src/desktop/components/make-purchase/member-card.js